import { combineLatest, Observable, of } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { Organization } from '../organization'
import { organizationSelectors } from '../organization.selectors'
import { Sale } from '../../sale/sale'
import { saleItemSelectors } from '../../sale/sale-item/sale-item.selectors'
import { SaleItem } from '../../sale/sale-item/sale-item'
import { saleItemActions } from '../../sale/sale-item/sale-item.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { saleSelectors } from '../../sale/sale.selectors'
import { userRoleActions } from '../../role/user-role/user-role.actions'
import { ActivatedRoute, Router } from '@angular/router'
import { organizationActions } from '../organization.actions'
import { OrganizationService } from '../organization.service'

@Component({
  selector: 'organization-sale-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OrganizationSaleTabComponent implements OnInit {
  public organization$: Observable<Organization>
  public organizationId$: Observable<number>
  public saleItems$: Observable<SaleItem[]>
  public sales$: Observable<Sale[]>

  public form: UntypedFormGroup

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private organizationService: OrganizationService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.organizationService.showModal) {
      this.activeRoute.params.pipe(take(1)).subscribe((params) => {
        if (params.hasOwnProperty('organizationId')) {
          this.organizationId$ = of(Number(params['organizationId']))
        }
      })
    } else {
      this.organizationId$ = this.store
        .select(organizationSelectors.selectIdRouteParam)
        .pipe(filter((id) => Boolean(id)))
    }

    this.organizationId$.pipe(take(1)).subscribe((organizationId) =>
      this.store.dispatch(
        organizationActions.fetchOneById({
          id: organizationId,
          params: RequestQueryBuilder.create({
            join: [{ field: 'roles' }]
          })
        })
      )
    )

    this.organization$ = this.organizationId$.pipe(
      switchMap((organizationId) =>
        this.store.select(organizationSelectors.selectById, organizationId)
      )
    )

    this.organizationId$.pipe(take(1)).subscribe((organizationId) => {
      this.store.dispatch(
        userRoleActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: { organizationId: organizationId },
            join: [{ field: 'member' }]
          })
        })
      )

      this.store.dispatch(
        saleItemActions.fetchMany({
          params: RequestQueryBuilder.create({
            join: [
              { field: 'sale' },
              { field: 'product' },
              { field: 'product.translations' },
              { field: 'subscription' },
              { field: 'subscription.translations' },
              { field: 'course' },
              { field: 'course.translations' },
              { field: 'sale.organization' },
              { field: 'sale.customer' }
            ],
            search: { 'sale.organizationId': organizationId }
          })
        })
      )
    })

    this.sales$ = combineLatest([
      this.organizationId$,
      this.store.select(saleSelectors.selectAll),
      this.store.select(saleItemSelectors.selectAll)
    ]).pipe(
      map(([organizationId, sales, saleItems]) => {
        return sales.filter((sale) => sale.organizationId == organizationId)
      })
    )
  }

  onRowClicked(row: SaleItem) {
    this.router.navigateByUrl(`/sales/${row.saleId}`)
  }
}
